import { memo } from 'react';
import './style.scss';
import Sidebar from '../Sidebar';

const SidebarWrapper = ({ user, handleToggle }) => {
  return (
    <div className={`sidebarwrapper_main`}>
      <Sidebar user={user} handleToggle={handleToggle} />
    </div>
  );
};

export default memo(SidebarWrapper);
